module.exports = __webpack_public_path__ + "static/100-robot-9060a0327a8a2c392737f695e2449819.jpg";